import PropTypes from 'prop-types';
import RentAcSocket from './components/RentAcSocket';
import Rent50Socket from './components/Rent50Socket';
import Rent75Socket from './components/Rent75Socket';
import Rent150Socket from './components/Rent150Socket';
import RentDue from './components/RentDue';

const BasicRent = ({statement}) => {

  const {
    socketsAc, 
    sockets50, 
    sockets75,
    sockets150,
    rentActualAc,
    rentActual50,
    rentActual75,
    rentActual150,
  } = statement.data;

  const totalRentDue = rentActualAc + rentActual50 + rentActual75 + rentActual150;

  return (
    <div>      
      {!!socketsAc && <RentAcSocket statement={statement}/>}
      {!!sockets50 && <Rent50Socket statement={statement}/>}
      {!!sockets75 && <Rent75Socket statement={statement}/>}
      {!!sockets150 && <Rent150Socket statement={statement}/>}
      <RentDue rentDue={totalRentDue}/>
    </div>
  )
}

export default BasicRent;

BasicRent.propTypes = {
  statement: PropTypes.object.isRequired,
};